export default __webpack_public_path__ + "static/media/antecna-logo.812b5e68.svg";